import React from 'react';

// Vouchers / Designs / Sales sub-navigation. Counts are optional —
// when null the chip is suppressed.
const SubNav = ({ active, onChange, counts = {}, visible = null }) => {
  const tabs = [
    { id: 'vouchers', label: 'Vouchers' },
    { id: 'designs',  label: 'Designs' },
    { id: 'sales',    label: 'Sales' },
  ];
  return (
    <div className="v2-subnav" role="tablist">
      {tabs.filter((tab) => !visible || visible.includes(tab.id)).map((tab) => {
        const count = counts[tab.id];
        const isActive = active === tab.id;
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            className={`v2-subnav-tab ${isActive ? 'active' : ''}`}
            onClick={() => onChange(tab.id)}
          >
            {tab.label}
            {count != null && <span className="v2-subnav-count">{count}</span>}
          </button>
        );
      })}
    </div>
  );
};

export default SubNav;
